module.exports = __webpack_public_path__ + "static/img/SM.5fe08e47.svg";